import { captureException } from '@sentry/react';

const isPKCEError = error => {
  return (
    error?.message?.includes('PKCE codeVerifier') ||
    error?.message?.includes('codeVerifier from storage')
  );
};

export const clearAuthCodeOnAuthSdkError = err => {
  const actualError = err && err.error ? err.error : err;
  try {
    if (
      actualError &&
      actualError.name === 'AuthSdkError' &&
      typeof window !== 'undefined'
    ) {
      const urlParams = new URLSearchParams(window.location.search);
      const hasCode = urlParams.has('code');

      if (isPKCEError(actualError)) {
        if (hasCode) {
          window.location.replace(window.location.origin);
        } else {
          sessionStorage.removeItem('okta-pkce-storage');
          window.location.replace(window.location.origin);
        }
        return;
      }

      if (hasCode) {
        window.location.replace(window.location.origin);
      }
    }
  } catch (e) {
    captureException(e, {
      tags: { section: 'AuthCallback' },
      extra: { message: 'Failed to clear auth code on auth SDK error' },
    });
  }
};


